enum HeaderType {
    
    MainHeader = "mainHeader",
    SubHeader = "subHeader"
}

export default HeaderType;
